import { render } from "./ChannelSegmentsForBridgePlacement.vue?vue&type=template&id=6c27fd7b&ts=true"
import script from "./ChannelSegmentsForBridgePlacement.vue?vue&type=script&lang=ts"
export * from "./ChannelSegmentsForBridgePlacement.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/tumeda/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__